<ng-container *ngIf="organization">
    <div class="menus">
        <button *ngIf="rights.DASHBOARD"
                mat-button
                class="menu"
                [class.selected]="currentMenu == MENU_DASHBOARD"
                [routerLink]="dashboardUrl">
            {{ 'Dashboard' | translate }}
        </button>
        <button *ngIf="rights.LIBRARIES"
                mat-button
                class="menu"
                [class.selected]="currentMenu == MENU_LIBRARIES"
                [routerLink]="'/' + organization.code + '/libraries'">
            {{ 'Libraries' | translate }}
        </button>
        <button *ngIf="rights.COACHES || rights.GUESTS"
                mat-button
                class="menu"
                [class.selected]="currentMenu == MENU_SUPERCOACHS || currentMenu == MENU_COACHS || currentMenu == MENU_GUEST"
                [matMenuTriggerFor]="staffMenu">
            {{ 'Staff' | translate }}
        </button>
        <mat-menu #staffMenu="matMenu" xPosition="before">
            <button *ngIf="rights.COACHES"
                    mat-menu-item
                    class="menu-button"
                    [class.selected]="currentMenu == MENU_SUPERCOACHS"
                    [routerLink]="'/' + organization.code + '/super-coaches'">
                {{ 'Super_Coaches' | translate }}
            </button>
            <button *ngIf="rights.COACHES"
                    mat-menu-item
                    class="menu-button"
                    [class.selected]="currentMenu == MENU_COACHS"
                    [routerLink]="'/' + organization.code + '/coaches'">
                {{ 'Coaches' | translate }}
            </button>
            <button *ngIf="rights.GUESTS"
                    mat-menu-item
                    class="menu-button"
                    [class.selected]="currentMenu == MENU_GUEST"
                    [routerLink]="'/' + organization.code + '/guests'">
                {{ 'Guests' | translate }}
            </button>
        </mat-menu>
        <button *ngIf="rights.TEAMS"
                mat-button
                class="menu"
                [class.selected]="currentMenu == MENU_TEAMS"
                [routerLink]="'/' + organization.code + '/teams'">
            {{ 'Teams' | translate }}
        </button>
        <button *ngIf="rights.ATHLETES"
                mat-button
                class="menu"
                [class.selected]="currentMenu == MENU_ATHLETES"
                [routerLink]="'/' + organization.code + '/athletes'">
            {{ 'Athletes' | translate }}
        </button>
    </div>
    <button mat-mini-fab
            class="menus-compact"
            color="default"
            [matMenuTriggerFor]="moreMenu">
        <mat-icon color="accent">more_vert</mat-icon>
    </button>
    <mat-menu #moreMenu="matMenu"
              xPosition="before">
        <button *ngIf="rights.DASHBOARD"
                mat-menu-item
                class="menu"
                [class.selected]="currentMenu == MENU_DASHBOARD"
                [disabled]="true">
            {{ 'Dashboard' | translate }}
        </button>
        <button *ngIf="rights.LIBRARIES"
                mat-menu-item
                class="menu"
                [class.selected]="currentMenu == MENU_LIBRARIES"
                [routerLink]="'/' + organization.code + '/libraries'">
            {{ 'Libraries' | translate }}
        </button>
        <button *ngIf="rights.COACHES"
                mat-menu-item
                class="menu-button"
                [class.selected]="currentMenu == MENU_SUPERCOACHS"
                [routerLink]="'/' + organization.code + '/super-coaches'">
            {{ 'Super_Coaches' | translate }}
        </button>
        <button *ngIf="rights.COACHES"
                mat-menu-item
                class="menu-button"
                [class.selected]="currentMenu == MENU_COACHS"
                [routerLink]="'/' + organization.code + '/coaches'">
            {{ 'Coaches' | translate }}
        </button>
        <button *ngIf="rights.GUESTS"
                mat-menu-item
                class="menu-button"
                [class.selected]="currentMenu == MENU_GUEST"
                [routerLink]="'/' + organization.code + '/guests'">
            {{ 'Guests' | translate }}
        </button>
        <button *ngIf="rights.TEAMS"
                mat-menu-item
                class="menu"
                [class.selected]="currentMenu == MENU_TEAMS"
                [routerLink]="'/' + organization.code + '/teams'">
            {{ 'Teams' | translate }}
        </button>
        <button *ngIf="rights.ATHLETES"
                mat-menu-item
                class="menu"
                [class.selected]="currentMenu == MENU_ATHLETES"
                [routerLink]="'/' + organization.code + '/athletes'">
            {{ 'Athletes' | translate }}
        </button>
    </mat-menu>
</ng-container>
